import logo from "./img/Nu Kenzie.svg";
import img from "./img/Group 272.svg";
import "./Styles/styles.css";

export const HomePage = ({ setIsLogged }) => {
  return (
    <section className="home-page">
      <main className="home-page-container">
        <div className="home-page-title">
          <figure>
            <img src={logo} alt="logo" />
          </figure>
          <h1>Centralize o controle das suas finanças</h1>
          <p>de forma rápida e segura</p>
          <button onClick={() => setIsLogged(true)}>iniciar</button>
        </div>
        <div>
          <figure>
            <img src={img} className="home-page-img" alt="homePage-img" />
          </figure>
        </div>
      </main>
    </section>
  );
};
